import React from 'react';
import PropTypes from 'prop-types';
import Container from './Grid.styles';

const Grid = ({
  columns = 4,
  mobileColumns = 2,
  xsMobileColumns = null,
  withMarginBottom = false,
  children,
  ...rest
}) => {
  // if no custom value for xsMobileColumns, take value from mobileColumns
  const xs = xsMobileColumns ?? mobileColumns;

  return (
    <Container
      columns={columns}
      mobileColumns={mobileColumns}
      xsMobileColumns={xs}
      withMarginBottom={withMarginBottom}
      {...rest}
    >
      {children}
    </Container>
  );
};

Grid.propTypes = {
  children: PropTypes.node.isRequired,
  columns: PropTypes.number,
  mobileColumns: PropTypes.number,
  xsMobileColumns: PropTypes.number,
  withMarginBottom: PropTypes.bool
};

export default Grid;
